// @ts-nocheck
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { URLS } from "./_config";
import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
import Login from "./containers/login";
import MyProfile from "./containers/myProfile";
import RodeoEventContainer from "./containers/RodeoEvent/rodeoEvent";
import RodeoEventGameContainer from "./containers/RodeoEventGame/rodeoEventGame";
import AboutUsContainer from "./containers/cms/aboutUs/aboutUs";
import LegalContainer from "./containers/cms/legal/legal";
import HowToPlayContainer from "./containers/cms/howToPlay/howToPlay";
import TermOfUseContainer from "./containers/cms/termOfUse/termOfUse";
import Page404 from "./containers/page-404";
import CacheBuster from "./CacheBuster";
import LeaderboardContainer from "./containers/leaderboard/leaderboard";
import LeaderBoard from "./containers/leaderboard";
import RodeoTvImageContainer from "./containers/tv-image/tv-image";
import CmsContainer from "./containers/cms/cms";
import LoginWithEmail from "./containers/loginWithEmail";
import ForgotPassword from "./containers/forgot-password";
import ResetPassword from "./containers/reset-password";
import Register from "./containers/register";

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <Switch>
                <Route exact path={URLS.HOME} component={RodeoEventContainer} />
                <Route exact path={URLS.TV_IMAGE} component={RodeoTvImageContainer} />
                <Route exact path={URLS.USER.PROFILE} component={requireAuth(MyProfile)} />
                <Route exact path={URLS.CMS.CMS} component={CmsContainer} />
                <Route exact path={URLS.CMS.GAME_CMS} component={CmsContainer} />
                <Route exact path={URLS.CMS.ABOUT_US} component={AboutUsContainer} />
                <Route exact path={URLS.CMS.LEGAL} component={LegalContainer} />
                <Route exact path={URLS.EVENT.EVENT_GAMES} component={RodeoEventGameContainer} />
                <Route exact path={URLS.LOGIN} component={requireNoAuth(Login)} />
                <Route exact path={URLS.LOGIN_WITH_EMAIL} component={requireNoAuth(LoginWithEmail)} />
                <Route exact path={URLS.REGISTRATION} component={requireNoAuth(Register)} />
                <Route exact path={URLS.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                <Route exact path={URLS.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} />
                <Route exact path={URLS.CMS.TERM_OF_USE} component={TermOfUseContainer} />
                <Route exact path={URLS.CMS.HOW_TO_PLAY} component={HowToPlayContainer} />
                <Route exact path={URLS.EVENT.LEADERBOARD} component={LeaderBoard} />
                <Route path="*" component={reqLayout(Page404)} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
